<template>
  <v-snackbar
  v-model="show"
  :color="color"
  :timeout="timeout"
  bottom
  right
  >
  <v-icon dark>{{ icon }}</v-icon>
    {{message}}
    <v-btn flat dark icon @click.native="show = false"><v-icon>close</v-icon></v-btn>
  </v-snackbar>
</template>

<script>
// import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      show: false,
      message: '',
      type: '',
      timeout: 2000
    }
  },
  computed: {
    color () {
      if (this.type === 'error') {
        return 'error'
      }
      if (this.type === 'warning') {
        return 'warning'
      }
      if (this.type === 'success') {
        return 'success'
      }
      return 'info'
    },
    icon () {
      if (this.type === 'error') {
        return 'error'
      }
      if (this.type === 'warning') {
        return 'warning'
      }
      if (this.type === 'success') {
        return 'check'
      }
      return 'info'
    }
  },
  created () {
    this.$store.watch((state) => state.snackbar.snack.message, () => {
      const { message, type, timeout } = this.$store.state.snackbar.snack
      if (message !== '') {
        this.timeout = timeout || 2000
        this.message = message
        this.type = type
        this.show = true
        this.$store.commit('snackbar/setSnack', {message: '', type: ''})
      }
    })
  },
  watch: {
    '$route' (to, from) {
      if (from.name === 'Login' && to.name !== 'Login') {
        this.show = false
        this.message = ''
        this.type = ''
      }
    }
  }
}
</script>
